module.exports = __webpack_public_path__ + "static/media/use-case-13.e4b0a12d.png";